import askAnswer from './ask_answer/en'
import aiTranslate from './ai_translate/en'
import creations from './creations/en'
import aside from './component/aside/en'
import header from './component/header/en'
import history from './component/history/en'
import subscribe from './component/subscribe/en'
import toolInput from './component/toolInput/en'
import payPopup from './component/pay_popup/en'
import login from './component/login/en'

export default {
  ...askAnswer,
  ...aiTranslate,
  ...creations,
  ...aside,
  ...header,
  ...history,
  ...subscribe,
  ...toolInput,
  ...payPopup,
  ...login
}
